export default __webpack_public_path__ + "static/media/chem.3892c7ec.jpg";